var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pet_profile_image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.46,
    y: 0.46,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.46,
    y: 0.46,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "profile_image_copy",
    "data-name": "profile image copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picture"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300.13,
    cy: 300.46,
    r: 300,
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.42,
    y: 122.34,
    width: 353.25,
    height: 355.32,
    rx: 30.89,
    fill: "#7effaa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.13,
    y: 158.9,
    width: 281.92,
    height: 231.88,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.02,
    cy: 217.93,
    rx: 39.15,
    ry: 39.02,
    fill: "#00d89a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.45,239.56c-6.89-12.29-18.67-12.58-26.17-.64L289.4,297.65c-7.5,11.94-22.44,15.73-33.2,8.42s-27.06-4.5-36.2,6.22l-36.74,43.16c-9.15,10.76-5.06,19.53,9.07,19.53H402.71c14.13,0,20.05-10.05,13.16-22.36Z",
    fill: "#00d89a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProfileImage);
export default __webpack_public_path__ + "static/media/pet_profile_image.ac56f5ebec82f18db6d248b4613fa8d5.svg";
export { ForwardRef as ReactComponent };